import { render, staticRenderFns } from "./AppointmentR.vue?vue&type=template&id=9decd54c&"
import script from "./AppointmentR.vue?vue&type=script&lang=js&"
export * from "./AppointmentR.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentR.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports